<mat-card class="full-height-container">
  <mat-tab-group #tabs [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="changeImportType()" class="full-height-container">
    <mat-tab label="{{ 'dataManagement.import.titleImport' | transloco }}">
      <div class="full-height-container tab-container">
        <div class="settings-container">
          <div class="margin-div buttons-container">
            <mat-button-toggle-group
              hideSingleSelectionIndicator
              name="showArchive"
              [formControl]="archiveControl"
              class="inner-archive-button-container">
              <mat-button-toggle [value]="false" matTooltip="{{ 'dataManagement.import.import.archive.noArchiveButtonHint' | transloco }}">
                <div class="toggle-icon-button">
                  <mat-icon svgIcon="import-new"></mat-icon>
                  {{ 'dataManagement.import.import.archive.noArchiveButton' | transloco }}
                </div>
              </mat-button-toggle>
              <mat-button-toggle [value]="true" matTooltip="{{ 'dataManagement.import.import.archive.archiveButtonHint' | transloco }}">
                <div class="toggle-icon-button">
                  <mat-icon fontIcon="archive"></mat-icon>
                  {{ 'dataManagement.import.import.archive.archiveButton' | transloco }}
                </div>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <mat-divider></mat-divider>
          <h3 class="table-header">{{ 'dataManagement.import.titlePackagingType' | transloco }}</h3>
          <div class="margin-div buttons-container">
            <mat-button-toggle-group
              hideSingleSelectionIndicator
              vertical
              [formControl]="packagingPartControl"
              class="inner-button-container"
              name="packagingType"
              aria-label="Packaging Type">
              <mat-button-toggle [value]="packagingPartEnum.Material">
                {{ 'dataManagement.import.compositeMaterial' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle [value]="packagingPartEnum.Component">
                {{ 'dataManagement.import.packagingComponent' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle [value]="packagingPartEnum.Unit"> {{ 'dataManagement.import.packagingUnit' | transloco }}</mat-button-toggle>
              <mat-button-toggle [value]="packagingPartEnum.System"> {{ 'dataManagement.import.packagingSystem' | transloco }}</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <mat-divider></mat-divider>
          <h3 class="table-header">{{ 'dataManagement.import.titleImportSettings' | transloco }}</h3>
          <div class="margin-div buttons-container">
            <mat-button-toggle-group
              hideSingleSelectionIndicator
              vertical
              class="inner-button-container"
              name="importType"
              #importTypeGroup="matButtonToggleGroup"
              [value]="selectedImportType">
              <mat-button-toggle (click)="importWithTracking()" [value]="importTypeEnum.WithTracking" class="long-text-label import-with-tracking">
                {{ 'dataManagement.import.import.importType.withTracking' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle (click)="importWithoutTracking()" [value]="importTypeEnum.WithoutTracking" class="long-text-label">
                {{ 'dataManagement.import.import.importType.withoutTracking' | transloco }}
              </mat-button-toggle>
            </mat-button-toggle-group>
            <span class="hint-container">
              <span *ngIf="importTypeGroup.value === importTypeEnum.WithTracking" class="hint">
                {{ 'dataManagement.import.import.importType.withTrackingHint' | transloco }}
              </span>
              <span *ngIf="importTypeGroup.value === importTypeEnum.WithoutTracking" class="hint">
                {{ 'dataManagement.import.import.importType.withoutTrackingHint' | transloco }}
              </span>
            </span>
          </div>
          <mat-divider></mat-divider>
          <div class="margin-div buttons-container">
            <div class="inner-button-container">
              <button mat-raised-button color="primary" (click)="proceedWithImport()" [disabled]="importTypeGroup.value == null || selectedCandidates.length < 1" type="button">
                {{ 'dataManagement.import.buttons.proceed' | transloco }} <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="margin-div buttons-container">
            <div class="inner-button-container">
              <button mat-raised-button color="warn" (click)="removeCandidates()" [disabled]="selectedCandidates.length < 1" type="button">
                {{ 'dataManagement.import.buttons.remove' | transloco }}
              </button>
            </div>
          </div>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="import-table-container">
          <h3 class="table-header">{{ tableTitleImports | transloco }}</h3>
          <div class="local-scrolling-wrapper">
            <app-import-html
              #importHtml
              [displayedColumns]="displayedColumns"
              [dataSource]="filteredDataSourceImports"
              [selectedCandidates]="selectedCandidates"
              [packagingPart]="packagingPartControl.value"
              [isChange]="false"
              (candidatesSelected)="setSelectedImportCandidates($event)"
              (navigationClicked)="navigateToCandidate($event.candidate)">
            </app-import-html>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'dataManagement.import.titleChangeTracking' | transloco }}">
      <div class="full-height-container tab-container">
        <div class="settings-container">
          <h3 class="table-header">{{ 'dataManagement.import.titlePackagingType' | transloco }}</h3>
          <div class="margin-div buttons-container">
            <mat-button-toggle-group
              hideSingleSelectionIndicator
              vertical
              [formControl]="packagingPartControl"
              class="inner-button-container"
              name="packagingType"
              aria-label="Packaging Type">
              <mat-button-toggle [value]="packagingPartEnum.Material"> {{ 'dataManagement.import.compositeMaterial' | transloco }}</mat-button-toggle>
              <mat-button-toggle [value]="packagingPartEnum.Component"> {{ 'dataManagement.import.packagingComponent' | transloco }}</mat-button-toggle>
              <mat-button-toggle [value]="packagingPartEnum.Unit"> {{ 'dataManagement.import.packagingUnit' | transloco }}</mat-button-toggle>
              <mat-button-toggle [value]="packagingPartEnum.System"> {{ 'dataManagement.import.packagingSystem' | transloco }}</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <mat-divider></mat-divider>
          <h3 class="table-header">{{ 'dataManagement.import.titleImportSettings' | transloco }}</h3>
          <div class="margin-div buttons-container">
            <mat-button-toggle-group
              hideSingleSelectionIndicator
              vertical
              class="inner-button-container"
              name="changesType"
              #changesTypeGroup="matButtonToggleGroup"
              [value]="selectedChangeType">
              <mat-button-toggle (click)="acceptChangesWithTrackingOverwrite()" [value]="changeTypeEnum.WithTrackingOverwrite" class="long-text-label import-with-tracking">
                {{ 'dataManagement.import.changes.importType.withTrackingOverwrite' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle (click)="acceptChangesWithTrackingNew()" [value]="changeTypeEnum.WithTrackingNew" class="long-text-label import-with-tracking">
                {{ 'dataManagement.import.changes.importType.withTrackingNew' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle (click)="acceptChangesWithoutTracking()" [value]="changeTypeEnum.WithoutTracking" class="long-text-label">
                {{ 'dataManagement.import.changes.importType.withoutTracking' | transloco }}
              </mat-button-toggle>
            </mat-button-toggle-group>
            <span class="hint-container">
              <span *ngIf="changesTypeGroup.value === changeTypeEnum.WithTrackingOverwrite" class="hint">
                {{ 'dataManagement.import.changes.importType.withTrackingOverwriteHint' | transloco }}
              </span>
              <span *ngIf="changesTypeGroup.value === changeTypeEnum.WithTrackingNew" class="hint">
                {{ 'dataManagement.import.changes.importType.withTrackingNewHint' | transloco }}
              </span>
              <span *ngIf="changesTypeGroup.value === changeTypeEnum.WithoutTracking" class="hint">
                {{ 'dataManagement.import.changes.importType.withoutTrackingHint' | transloco }}
              </span>
            </span>
          </div>
          <mat-divider></mat-divider>
          <div class="margin-div buttons-container">
            <div class="inner-button-container">
              <button mat-raised-button color="primary" (click)="proceedWithChange()" [disabled]="changesTypeGroup.value == undefined || selectedChanges.length < 1" type="button">
                {{ 'dataManagement.import.buttons.proceed' | transloco }} <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="margin-div buttons-container">
            <div class="inner-button-container">
              <button mat-raised-button color="warn" [disabled]="selectedChanges.length < 1" (click)="removeChanges()" type="button">
                {{ 'dataManagement.import.buttons.remove' | transloco }}
              </button>
            </div>
          </div>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="import-table-container">
          <h3 class="table-header">{{ tableTitleChanges | transloco }}</h3>
          <div class="local-scrolling-wrapper">
            <app-import-html
              #changeHtml
              [displayedColumns]="displayedColumns"
              [dataSource]="dataSourceChanges"
              [selectedCandidates]="selectedChanges"
              [packagingPart]="packagingPartControl.value"
              [isChange]="true"
              (candidatesSelected)="setSelectedImportChanges($event)"
              (navigationClicked)="navigateToChange($event.candidate, $event.navigateToCurrentVersion)">
            </app-import-html>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-card>
